export const en = {
  createYourOwn: {
    SIGN_IN_TO_USE_THIS_TEMPLATE:
      'Sign in or create an account to customize this design as your own.',
    CUSTOMIZE_THIS_DESIGN_AS_YOUR_OWN: 'Customize this design as your own',
    MAKE_YOUR_OWN: 'Customize Design',
    SIGN_IN_OR_SIGN_UP: 'Sign in or Sign up',
  },
  designLocked: {
    DESIGN_LOCKED_TITLE: 'This design is being created',
    DESIGN_LOCKED_TEXT:
      'This design is still in the process of being created. Try refreshing in a couple of minutes.',
  },
  designPrivate: {
    DESIGN_PRIVATE_TITLE: 'This design is private',
    DESIGN_PRIVATE_TEXT:
      'The person who shared this designed marked it as private. Login or make the design public to see it.',
  },
  designEmpty: {
    NO_RESULTS_TITLE: 'This design is empty',
    NO_RESULTS_MESSAGE:
      'The person who created this design has not added anything yet.',
  },
  design404: {
    TITLE: 'Unable to find the design',
    MESSAGE:
      'The design you are looking for does not exist or has been deleted.',
  },
  common: {
    LOADING: 'Loading...',
    ERROR: 'Error',
    SUCCESS: 'Success',
    SOMETHING_WENT_WRONG: 'Something went wrong',
  },
  actionBar: {
    DOWNLOAD: 'Download PDF',
    SIGN_OUT: 'Sign out',
  },
  companySwitcher: {
    SWITCH_COMPANIES: 'Switch companies',
  },
  viewer: {
    PROMPT_TEXT: 'Try now: Click on a product to see more information',
    VIRTUALS_ARE_ILLUSTRATIVE_TEXT:
      'Virtual product mockups are for illustrative purposes. The final decoration may differ.',
  },
  design: {
    DISCLAIMER:
      'Product prices and availability may change. Please confirm before ordering.',
  },
  productSidebar: {
    PRODUCT_INFO: 'Product Information',
    COLORS: 'Color Swatches',
    SIZES: 'Sizes',
    MATERIALS: 'Materials',
    PRICING: 'Pricing',
    MOQ: 'Minimum order quantity',
    READ_FULL_DESCRIPTION: 'Read full description',
    DOWNLOAD: 'Download',
    NO_IMAGE_AVAILABLE: 'No image available',
    VIEW_ON_OUR_WEBSITE: 'View on our website',
  },
};

export type LocaleMessages = typeof en;
